import { defineComponent as _defineComponent } from 'vue'
import { watch } from 'vue';
// Can be replaced with native Vue Teleport when on Vue 3
import Teleport from 'vue2-teleport';

import { useRoutingStore } from '@/helpers/composables/useStores';
import { enableScroll } from '@/helpers/scroll-helper';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

interface BaseModalProps {
	subTitle?: string;
	closable?: boolean;
	hasHeader?: boolean;
	hasFooter?: boolean;
	disableTeleport?: boolean;
	backgroundColor?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModalNew',
  props: {
    subTitle: { default: '' },
    closable: { type: Boolean, default: true },
    hasHeader: { type: Boolean, default: true },
    hasFooter: { type: Boolean, default: false },
    disableTeleport: { type: Boolean, default: false },
    backgroundColor: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'close', display: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const { activeRoute } = useRoutingStore();





watch(activeRoute, () => {
	enableScroll();
	emit('close', false);
});

return { __sfc: true,activeRoute, emit, Teleport, faTimes }
}

})